const templateUrl = require('./close.html');

const ctrl = require('./close.controller');

module.exports = angular.module('msi.modals.close', [
  ctrl.module
]).name;

angular.module(module.exports)
  .component('ogCloseModal', {
    templateUrl: templateUrl,
    controller: ctrl.name
  });
